<template>
  <div class="app">
    <div id="wrapper">
      <NavBar />
    </div>

    <div class="main-content is-fullwidth">
      <router-view />
    </div>
    <footer class="footer">
      <div class="is-flex-tablet is-flex-wrap-wrap">
        <div class="is-flex">
          <img
            src="@/images/tng-logo.svg"
            class="mb-1"
            style="max-width: 32px; height: auto"
          />
          <span class="mr-5">0125659500</span>
        </div>
        <a
          class="mr-5 mb-1"
          style="display: block"
          :href="'tel:' + SUPPORT_CONTACT"
          >Phone or WhatsApp: {{ SUPPORT_CONTACT }}</a
        >
        <a class="mb-1" style="display: block" :href="'mailto:' + SUPPORT_EMAIL"
          >Email: {{ SUPPORT_EMAIL }}</a
        >
      </div>
      <hr class="black-line my-0" />
      <p class="help">
        Call us if not satisfy and you will get 100% full refund immediately
      </p>
      <div class="has-text-centered">
        <p id="year">Copyright (c)</p>
        <p>KPR Internet Solutions Sdn Bhd</p>
        <P>202001026065 (1382385-k)</P>
      </div>
    </footer>

    <div id="modal-placeholder"></div>

    <div class="modal" :class="{ 'is-active': isLoading }">
      <div class="modal-background loading-modal-background"></div>
      <div class="modal-content has-text-centered">
        <img src="@/images/loading.gif" alt="loading..." />
      </div>
    </div>

    <TransitionGroup class="toast-container" name="fade" tag="div">
      <Toast
        v-for="msg in messages"
        :key="msg.id"
        :class="msg.type"
        :content="msg.content"
        @on-close="removeMessage(msg.id)"
      ></Toast>
    </TransitionGroup>
  </div>
</template>

<script setup>
import { computed, onMounted } from "vue";
import { useStore } from "vuex";

import NavBar from "@/components/NavBar";
import Toast from "@/components/Toast";
import { SUPPORT_EMAIL, SUPPORT_CONTACT } from "@/utils";

const store = useStore();

const routename = window.location.pathname;
const urlParams = new URLSearchParams(window.location.search);
const isSignUp = routename == "/sign-up";
const isGoogleLogin = urlParams.has("state") && urlParams.has("code");
const isResetPassword = routename.includes("/reset-password/");
const isActivateAccount = routename.includes("/activate-account/");
if (!isSignUp && !isGoogleLogin && !isResetPassword && !isActivateAccount) {
  store.dispatch("tryAutoLogin");
}

onMounted(() => {
  document.getElementById("year").innerHTML += new Date().getFullYear();
});

const isLoading = computed(() => store.getters.isLoading);
const messages = computed(() => store.getters.messages);

const removeMessage = (id) => {
  store.dispatch("removeMessage", id);
};
</script>

<style lang="scss">
@import "../mybulma/sass/mystyles.scss";

.app {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: stretch;

  .main-content {
    flex-grow: 1;
  }

  .loading-modal-background {
    background-color: rgba(256, 256, 256, 0.5);
  }
}
</style>

<style scoped>
.toast-container {
  position: fixed;
  right: 30px;
  top: 4rem;
  min-width: 250px;
  max-width: 400px;
  z-index: 41;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
  right: -150px;
}
.fade-move,
.fade-enter-active {
  transition: all 0.3s ease-out;
}
.fade-leave-active {
  transition: all 0.3s ease-in;
}
.fade-leave-active:not(:only-child) {
  position: absolute;
}
.fade-enter-to,
.fade-leave-from {
  opacity: 1;
  right: 0;
}
</style>
